__turbopack_context__.v({
  "arrow": "animated-arrow-module__PvWYaG__arrow",
  "first": "animated-arrow-module__PvWYaG__first",
  "second": "animated-arrow-module__PvWYaG__second",
});
